import React from 'react'

import { ButtonClean, Colors, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import { getAffiliateDescription } from '../../../../../../modules/Recommendations/modules/ReferralRecommendation/utils/getAffiliateDescription'
import type { AffiliateReferral } from '../../Referrals.types'
import * as S from './ReferralsListItem.styled'

type ReferralListItemProps = {
  item: AffiliateReferral
}

export const ReferralListItem: React.FC<ReferralListItemProps> = ({ item }) => {
  return (
    <S.Container>
      <S.ContentWrapper>
        <S.LeftContainer>
          <S.ShopNameContainer>
            <ButtonClean label={item.shopName} href={`${item.shopDomain}`} target="_blank" />
            <Tooltip reference={<QuestionMarkIcon color={Colors.GS600} width={12} />}>
              {getAffiliateDescription(item.affiliateTypeId).description}
            </Tooltip>
          </S.ShopNameContainer>

          <S.AffiliateType>{getAffiliateDescription(item.affiliateTypeId).name}</S.AffiliateType>
        </S.LeftContainer>

        <S.DateRange>
          {item.fromTime.toLocaleDateString()} - {item.toTime.toLocaleDateString()}
        </S.DateRange>
      </S.ContentWrapper>
    </S.Container>
  )
}
